export type LanguageId = string

export default function getLanguage(id: LanguageId): string {
  switch (id.toLowerCase()) {
    case 'ar': return 'Arabic';
    case 'bg': return 'Bulgarian';
    case 'zh': return 'Chinese';
    case 'hr': return 'Croatian';
    case 'cs': return 'Czech';
    case 'da': return 'Danish';
    case 'nl': return 'Dutch';
    case 'et': return 'Estonian';
    case 'fi': return 'Finnish';
    case 'fr': return 'French';
    case 'ka': return 'Georgian';
    case 'de': return 'German';
    case 'el': return 'Greek';
    case 'hu': return 'Hungarian';
    case 'he': return 'Hebrew';
    case 'ja': return 'Japanese';
    case 'id': return 'Indonesian';
    case 'it': return 'Italian';
    case 'ko': return 'Korean';
    case 'mk': return 'Macedonian';
    case 'ms': return 'Malay';
    case 'no': return 'Norwegian';
    case 'pl': return 'Polish';
    case 'pt': return 'Portuguese';
    case 'ro': return 'Romanian';
    case 'ru': return 'Russian';
    case 'sk': return 'Slovakian';
    case 'sl': return 'Slovenian';
    case 'es': return 'Spanish';
    case 'sv': return 'Swedish';
    case 'sr': return 'Serbian';
    case 'tr': return 'Turkish';
    case 'vi': return 'Vietnamese';
    default: return 'English';
  }
}

/**
 * Returns the languages for which we have the translations of system questions
 */
export function getAvailableFormLanguages(): LanguageId[] {
  return ['en', 'fr', 'es', 'pt', 'de', 'ru', 'nl'];
}

export const DEFAULT_LANGUAGE = 'en';
